import React, { useReducer } from "react";

import localStorageKeys from "src/core/constants/local-storage-keys";

import { toast } from "react-toastify";
import {
  createUserService,
  enterOtpService,
  getUserService,
  resetPasswordService,
  updateNewPasswordService,
  updateUserService,
} from "src/core/services/user.service";

import UserContext from "../context/UserContext";

import { UserReducer } from "../reducer/UserReducer";

import {
  AUTH_ERROR,

  RESET_USER_PASSWORD,
  SET_AUTH_LOADING,
  SET_USER_LOADING,
  UPDATE_USER,
  UPDATE_USER_ERROR,
  VERIFY_OTP,
  VERIFY_OTP_ERROR,
} from "../types/user.type";

const initialUser = {
  user: null,
  beneficiary: { beneficiary: null, beneficiaries: [] },
  loading: false,
  isAuthLoading: false,
  error: null,
  isVerified: false,
  isAuth: false,
  isCompleted: false,
  isReset: false,
  isLoggedIn: false,
};

export const UserProvider = ({ children }) => {
  const [user, userDispatch] = useReducer(UserReducer, initialUser);
  const loading = (isLoading: boolean) => ({
    type: SET_USER_LOADING,
    isLoading,
  });
  const authLoading = (isLoading: boolean) => ({
    type: SET_AUTH_LOADING,
    isLoading,
  });

  // const loginUser = async (data) => {
  //   userDispatch(authLoading(true));
  //   try {
  //     const response = await loginUserService(data);
  //     console.log(response);

  //     if (response.data.data.authenticate) {
  //       localStorage.setItem(
  //         localStorageKeys.userId,
  //         response.data.data.authenticate.user.id
  //       );
  //       localStorage.setItem(
  //         localStorageKeys.token,
  //         response.data.data.authenticate.token
  //       );

  //       userDispatch({
  //         type: LOGIN_USER,
  //         payload: response.data.data.authenticate.user,
  //       });
  //     } else {
  //       toast.error("Incorrect email or Password");
  //       //   toast.
  //     }

  //     userDispatch(authLoading(false));
  //   } catch (error: any) {
  //     // console.log(error);
  //     userDispatch({
  //       type: AUTH_ERROR,
  //       payload: error?.response?.data?.errors,
  //     });
  //     toast.error("Error occured while, please check your internet settings");
  //     userDispatch(authLoading(false));
  //   }
  // };
  // function to get User
  const getUser = async (data) => {
    userDispatch(authLoading(true));
    try {
      const response = await getUserService(data);
      // console.log("Get USER:",user);
      if (response.data.errors) {
        toast.error("Incorrect email or Password");
      } else {
        const user = response.data.data.getUser.users[0];
        localStorage.setItem(localStorageKeys.userId, user.id);
        userDispatch({ type: UPDATE_USER, payload: user });
        //   toast.
      }

      userDispatch(authLoading(false));
    } catch (error: any) {
      userDispatch({
        type: AUTH_ERROR,
        payload: error?.response?.data?.errors,
      });
      //   toast.error("Error occured while");
      userDispatch(authLoading(false));
    }
  };

  // function to create User
  const createUser = async (data) => {
    userDispatch(loading(true));
    try {
      const response = await createUserService(data);
      if (response.data.errors) {
        toast.error("Email already exists");
      } else {
        const user = JSON.parse(response.data.data.user.object);
        userDispatch({ type: UPDATE_USER, payload: user });
        // localStorage.setItem(
        //   localStorageKeys.loginDetails,
        //   JSON.stringify({
        //     username: user.username,
        //     id: user.id,
        //   })
        // );
        toast.success("Account created successfully");
      }
      userDispatch(loading(false));
    } catch (error: any) {
      userDispatch({
        type: UPDATE_USER_ERROR,
        payload: error.response.data.errors,
      });
      toast.error("Error occured while creating a user");
      userDispatch(loading(false));
    }
  };
  // verify otp code
  const verifyOtp = async (data: any) => {
    userDispatch(loading(true));
    try {
      const response = await enterOtpService(data);
      if (response.data.errors) {
        toast.error("Invalid Verification Code");
      } else {
        const user = JSON.parse(response.data.data.user.object);
        userDispatch({
          type: VERIFY_OTP,
          payload: user,
        });

        localStorage.setItem(localStorageKeys.userId, user.id);
      }
      userDispatch(loading(false));
    } catch (error: any) {
      console.log(error.response.data);
      userDispatch({
        type: VERIFY_OTP_ERROR,
        payload: error.response.data.errors,
      });
      toast.error("Error occured while verifying OTP");
      userDispatch(loading(false));
    }
  };

  const updateUser = async (data: any, type = UPDATE_USER) => {
    userDispatch(loading(true));
    try {
      console.log("data:",data);

      const response = await updateUserService(data);
      if (response.data.errors) {
        toast.error("An error occured");
      } else {
        const user = JSON.parse(response.data.data.user.object);
        localStorage.setItem(localStorageKeys.userId, user.id);
        userDispatch({
          type: type,
          payload: user,
        });
        toast.success("User details updated succesfully !");
      }
      userDispatch(loading(false));
    } catch (error: any) {
      console.log(error.response.data);
      userDispatch({
        type: UPDATE_USER_ERROR,
        payload: error.response.data.errors,
      });
      toast.error("Error occured while updating user");
      userDispatch(loading(false));
    }
  };

  const updateNewPassword = async (data: any) => {
    userDispatch(loading(true));
    try {
      const response = await updateNewPasswordService(data);
      if (response.data.errors) {
        toast.error("An error occured");
      } else {
        const user = JSON.parse(response.data.data.user.object);
        userDispatch({
          type: UPDATE_USER,
          payload: user,
        });
        toast.success("User details updated succesfully !");
      }
      userDispatch(loading(false));
    } catch (error: any) {
      console.log(error.response.data);
      userDispatch({
        type: UPDATE_USER_ERROR,
        payload: error.response.data.errors,
      });
      toast.error("Error occured while updating user");
      userDispatch(loading(false));
    }
  };

  const resetPassword = async (data) => {
    userDispatch(loading(true));
    try {
      const response = await resetPasswordService(data);

      if (response.data.errors) {
        toast.error("Email does not exist.");
      } else {
        const user = JSON.parse(response.data.data.passwordReset.object);
        userDispatch({
          type: RESET_USER_PASSWORD,
          payload: user,
        });
        localStorage.setItem(
          localStorageKeys.loginDetails,
          JSON.stringify({
            username: user.username,
            id: user.id,
          })
        );
        toast.info("Reset code has been sent to your email !");
      }
      userDispatch(loading(false));
    } catch (error: any) {
      // console.log(error.response.data);
      userDispatch({
        type: UPDATE_USER_ERROR,
        payload: error?.response?.data?.errors,
      });
      toast.error("Error occured while resetting password");
      userDispatch(loading(false));
    }
  };

  return (
    <UserContext.Provider
      value={{
        user,
        getUser,
        // loginUser,
        createUser,
        userDispatch,
        updateUser,
        verifyOtp,
        resetPassword,
        updateNewPassword,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
